export function getExpirationTime(hours: number): Date {
	return new Date(Date.now() + hours * 60 * 60 * 1000);
}

export function uuidv4(): string {
	if (typeof crypto !== 'undefined' && (crypto as any).randomUUID) {
		return (crypto as any).randomUUID();
	}
	// Fallback RFC4122 v4
	const bytes = new Uint8Array(16);
	(crypto || (window as any).msCrypto).getRandomValues(bytes);
	bytes[6] = (bytes[6] & 0x0f) | 0x40; // version 4
	bytes[8] = (bytes[8] & 0x3f) | 0x80; // variant 10
	const toHex = (n: number) => n.toString(16).padStart(2, '0');
	const b = Array.from(bytes, toHex).join('');
	return `${b.slice(0, 8)}-${b.slice(8, 12)}-${b.slice(12, 16)}-${b.slice(
		16,
		20
	)}-${b.slice(20)}`;
}

export function getUTMParameters(): Record<string, string | null> {
	const p = new URLSearchParams(location.search);
	return {
		utm_source: p.get('utm_source'),
		utm_medium: p.get('utm_medium'),
		utm_campaign: p.get('utm_campaign'),
		utm_term: p.get('utm_term'),
		utm_content: p.get('utm_content'),
		utm_id: p.get('utm_id'),
	};
}
